var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "cancel-disabled": _vm.cancelDisabled,
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        title: _vm.title,
        "hide-footer": _vm.hideFooter,
        "hide-header": !_vm.title,
        size: _vm.size
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _vm.okBtnVisible
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: _vm.okBtnVariant },
                      on: {
                        click: function($event) {
                          return _vm.builtInOkFn()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.okBtnText || _vm.$t("dialog.ok-button")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.cancelFn
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: _vm.cancelBtnVariant },
                      on: {
                        click: function($event) {
                          return _vm.builtInCancelFn()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.cancelBtnText || _vm.$t("dialog.cancel-button")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.localValue,
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    },
    [
      _vm.content
        ? _c("div", {
            staticClass: "text-center",
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        : _vm._t("default"),
      _vm._v(" "),
      !_vm.hideFooter
        ? _c(
            "div",
            { staticClass: "cookie-checkbox-ctn" },
            [
              _vm.dontShowAgainCookie
                ? _c(
                    "base-checkbox",
                    {
                      staticClass: "text-center mb-0",
                      model: {
                        value: _vm.dontShowAgainChecked,
                        callback: function($$v) {
                          _vm.dontShowAgainChecked = $$v
                        },
                        expression: "dontShowAgainChecked"
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("dontShowAgain")) }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e26acf92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e26acf92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseDialog.vue
// module id = 1582
// module chunks = 116